import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import WalletGearModal from './WalletGearModal';
import manualTradeLogo from '../assets/manualtrade.jpg';
import obotLogo from '../assets/obot.jpg';
import gearsLogo from '../assets/gears.jpg';
import './MultiAssetTrading.css';

const MultiAssetTrading = () => {
  const [settingsOpen, setSettingsOpen] = useState(false);

  return (
    <div className="multi-asset-page">
      <header className="multi-asset-header">
        <Link to="/dashboard" className="multi-asset-back">
          ← Back to Dashboard
        </Link>
        <h1>Multi-Asset Trading</h1>
        <p className="subtitle">
          Hyperliquid tokenized stocks, indices, commodities &amp; FX — Omni MAP strategy at 2x; manual
          trades use each asset&apos;s HL max leverage.
          Configure your wallet and cash reserve in Settings, then trade manually or with oBot.
        </p>
      </header>

      <div className="multi-asset-actions">
        <Link to="/multi-asset/manual" className="multi-asset-btn">
          <img src={manualTradeLogo} alt="Manual Trading" className="multi-asset-btn-icon-img" />
          <span className="multi-asset-btn-title">Manual Trading</span>
          <span className="multi-asset-btn-desc">Queue trades with live order book</span>
        </Link>

        <Link to="/multi-asset/obot" className="multi-asset-btn multi-asset-btn-accent">
          <img src={obotLogo} alt="oBot Trading" className="multi-asset-btn-icon-img" />
          <span className="multi-asset-btn-title">oBot Trading</span>
          <span className="multi-asset-btn-desc">Automated Omni MAP execution</span>
        </Link>

        <button
          type="button"
          className="multi-asset-btn multi-asset-btn-settings"
          onClick={() => setSettingsOpen(true)}
        >
          <img src={gearsLogo} alt="Settings" className="multi-asset-btn-icon-img" />
          <span className="multi-asset-btn-title">Settings</span>
          <span className="multi-asset-btn-desc">Wallet, cash reserve &amp; encryption</span>
        </button>
      </div>

      <WalletGearModal
        open={settingsOpen}
        onClose={() => setSettingsOpen(false)}
        title="Hyperliquid wallet settings"
        view="settings"
      />
    </div>
  );
};

export default MultiAssetTrading;
